export default import.meta.ROLLDOWN_FILE_URL_JoDxeQ1xEKeZpTWUJ7TFQw